module.exports = __webpack_public_path__ + "static/img/岸基潮位站.5e2321b0.png";